import React, { useState, useEffect } from "react";
import { RadioGroup } from "@headlessui/react";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { useContext } from "react";
import { ManageModuleContext } from "context/ManageCompanyModuleContext";
import BreadCrumb from "components/lib/Global/BreadCrumb";
import { useSelector, useDispatch } from "react-redux";
import {
  editInitiatedTransactionChangeAsync,
  getAllInitiateTransactionChangeAsync,
} from "state/slices/initiateTransactionChange";
import Button from "components/lib/Shared/Button";
import format from "date-fns/format";
import { getMaintainYourCompanyReviewStatus } from "config/documentData";
import TableActionMenu from "components/lib/Shared/TableActionMenu";
import RecentChangesSubRow from "./subrow";
import Table from "components/lib/Global/ReactTable";
import { openModal } from "state/slices/modals";
import Approvals from "../Approvals";
import { ChevronLeftIcon } from "@heroicons/react/outline";
import ChangesContext from "context/ChangesContext";
import XIcon from "@heroicons/react/outline";
import { Constants } from "config/constants";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { createBatchNumber, setBatchNumber } from "state/slices/batchNumber";

const RecentChangesTable = (props) => {
  const { handleBackToManageYourCompanyDashboard } =
    useContext(ManageModuleContext);
  const [newRequestInitiated, setNewRequestInitiated] = useState(false);
  const { companyId } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const [initialRows, setInitialRows] = useState({});
  const history = useHistory();
  const { batchNo } = useSelector((state) => state.batchNumberSlice);

  const pages = [
    { name: "Home", href: "/companies", current: false },
    {
      name: "Maintain a company",
      current: false,
      href: "#",
      handleClick: handleBackToManageYourCompanyDashboard,
    },
    {
      name: "Changes",
      current: true,
      href: null,
      handleClick: false,
    },
  ];

  const handleView = (original) => {
    history.push(
      `/companies/${companyId}/dashboard/transactions/${original._id}/view`
    );
  };

  const handleEdit = (original) => {
    history.push(
      `/companies/${companyId}/dashboard/transactions/${original._id}/edit`
    );
  };
  const handleDelete = () => {};
  const handleGoBack = () => {};

  const handleInitiateNewRequest = async () => {
    if (!batchNo) {
      await dispatch(createBatchNumber());
    }
    setNewRequestInitiated(true);
  };

  useEffect(async () => {
    if (newRequestInitiated && batchNo) {
      if (!props.data[0].batchNo) {
        await dispatch(
          editInitiatedTransactionChangeAsync({
            companyId,
            formData: {
              documentId: props.data[0]._id,
              batchNo: batchNo,
            },
          })
        );
      }
      history.push(
        `/companies/${companyId}/dashboard/manage-your-company/changes`
      );
    }
  }, [newRequestInitiated, batchNo]);

  useEffect(() => {
    if (props.data[0]?.batchNo) {
      dispatch(setBatchNumber(props.data[0]?.batchNo));
    }
  }, [props.data]);

  const columns = [
    {
      Header: "Batch No.",
      accessor: "BatchNo",
      Cell: ({ row }) => row.original.batchNo || "-",
    },
    {
      Header: "Application Type",
      accessor: "applicationType",

      Cell: ({ row }) => {
        return row.original?.applicationType || "Incorporation";
      },
    },
    {
      Header: "Change Type",
      accessor: "changeType",
      Cell: ({ row: { original } }) => {
        const capitalize = (str) => {
          if (!str) return null;
          return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        };

        return capitalize(original?.changeType) || original?.type || "-";
      },
    },
    {
      Header: "Tnx No.",
      accessor: "TnxNo",
      Cell: ({ row: { original } }) => {
        return original?.trxRef || original?.registrationNumber || "-";
      },
    },
    {
      Header: "Date",
      Cell: ({ row: { original } }) => {
        const date = original?.createdAt || original?.createdAt;
        return date ? format(new Date(date), "yyyy/MM/dd") : "N/A";
      },
    },
    {
      Header: "Status",
      Cell: ({ row }) => {
        if (row?.original?.applicationType) {
          return getMaintainYourCompanyReviewStatus(row.original?.status);
        } else {
          return row.original?.status;
        }
      },
    },
    {
      Header: "Action",
      Cell: ({ row }) => {
        return (
          <div>
            <TableActionMenu
              row={row}
              renderViewAsSubRow={true}
              showViewBtn={true}
              viewWithoutSubRow={true}
              handleView={handleView}
              handleEdit={handleEdit}
              handleDelete={handleDelete}
            />
          </div>
        );
      },
    },
  ];

  // const closeModal = () => {
  //   setshowEditOfficialModal(false);
  // };

  return (
    <div className="text-sflPrimary">
      <>
        <RadioGroup className="my-4">
          <RadioGroup.Label className="text-base">
            <div>
              {/* <div className="bg-white container mx-auto px-4 mb-8">
                <div className="">
                  <BreadCrumb pages={pages} />
                </div>
              </div> */}
              <h2 className="pb-4 font-semibold text-title5">Recent Changes</h2>
              <h1 className="font-medium">
                Initiate transaction of existing business operations or
                ownership to Simple Formation Limited
              </h1>
            </div>
          </RadioGroup.Label>
        </RadioGroup>
        {props?.data?.length > 0 ? (
          <>
            <div className="py-4">
              <div className="mb-4">
                <div className="flex justify-between">
                  <span className="mt-4">A list of all recent changes</span>
                  <button
                    className="px-4 bg-gray-100"
                    onClick={handleInitiateNewRequest}
                  >
                    + Initiate New Request
                  </button>
                </div>
              </div>
              <Table
                columns={columns}
                data={props.data}
                dataRowCellStyle="pl-4 leading-snug py-2"
                paginate={true}
                totalRows={props.data.length || 10}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                renderRowSubComponent={() => {}}
              />{" "}
            </div>
          </>
        ) : (
          <div className="notification-container flex justify-center px-4 py-10 mt-2 mb-2 bg-gray-200 rounded-sm shadow-sm sm:rounded md:rounded-md relative">
            <h2 className="text-gray-900 font-normal">
              You have no transaction to proceed with the workflow
            </h2>
            {/* <span
                className="close-icon absolute top-2 right-2 cursor-pointer text-lg hover:bg-gray-300"
                onClick={() => setInitiateRequestModelChecker(true)}
              >
                <XIcon className="h-6 w-6" />
              </span> */}
          </div>
        )}
      </>
    </div>
  );
};

export default RecentChangesTable;
